import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconLake = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconLake",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M20.2 11.3 15.23 5l-3.37 4.09 1.82 2.2zm-4.98-5.07 1.35 1.64-.24.44-.78-.94-.68.93-.53-.89-.16.08zm-6.38.04L2 14.57h13.69zm.47 4.34-.9-1.22-1.03 1.23-.32-.55 1.78-2.18 1.37 1.67-.2-.1zm11.26 1.44s1.04 1.11 1.36 2.52c.43 1.97-1 3.12-5.7 2.89-1.6 0-3.32.48-4.84.9-3.2.9-5.5 1.55-4.05-3.15h9.74l-2.54-3.16z"
  })
}));
IconLake.displayName = 'IconLake';